import {
  SalaryCardActions,
  SalaryCardActionTypes,
  SalaryCardState,
} from 'store/types/salaryCard'

const initialState: SalaryCardState = {
  salaryCardListExcel: [],
  salaryCardListExcelError: null,
  salaryCardListExcelStatus: 'idle',
}

export const excelSalaryCardReducer = (
  state = initialState,
  action: SalaryCardActions
): SalaryCardState => {
  switch (action.type) {
    case SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_REQUEST:
      return {
        ...state,
        salaryCardListExcelStatus: 'loading',
        salaryCardListExcelError: null,
      }
    case SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_SUCCESS:
      return {
        ...state,
        salaryCardListExcelStatus: 'success',
        salaryCardListExcel: action.payload,
      }
    case SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_FAILURE:
      return {
        ...state,
        salaryCardListExcelStatus: 'failed',
        salaryCardListExcelError: action.payload,
      }
    case SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_RESET:
      return {
        ...state,
        salaryCardListExcel: initialState.salaryCardListExcel,
        salaryCardListExcelError: null,
        salaryCardListExcelStatus: 'idle',
      }
    default:
      return state
  }
}
